import { SVGProps } from '@components/Icon/types';

export const Bin = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 15 15"
    fill="none"
    {...props}>
    <path
      d="M9.14062 11.1328C9.39947 11.1328 9.60938 10.9229 9.60938 10.6641V5.97656C9.60938 5.71772 9.39947 5.50781 9.14062 5.50781C8.88178 5.50781 8.67188 5.71772 8.67188 5.97656V10.6641C8.67188 10.9229 8.88178 11.1328 9.14062 11.1328Z"
      fill={fill}
    />
    <path
      d="M5.85938 11.1328C6.11822 11.1328 6.32812 10.9229 6.32812 10.6641V5.97656C6.32812 5.71772 6.11822 5.50781 5.85938 5.50781C5.60053 5.50781 5.39062 5.71772 5.39062 5.97656V10.6641C5.39062 10.9229 5.60053 11.1328 5.85938 11.1328Z"
      fill={fill}
    />
    <path
      d="M9.375 1.99219C9.63384 1.99219 9.84375 1.78228 9.84375 1.52344C9.84375 1.26459 9.63384 1.05469 9.375 1.05469H5.625C5.36616 1.05469 5.15625 1.26459 5.15625 1.52344C5.15625 1.78228 5.36616 1.99219 5.625 1.99219H9.375Z"
      fill={fill}
    />
    <path
      d="M2.34375 2.46094C2.08491 2.46094 1.875 2.67084 1.875 2.92969C1.875 3.18853 2.08491 3.39844 2.34375 3.39844H2.8125V12.0234C2.8125 13.0828 3.675 13.9453 4.73438 13.9453H10.2656C11.325 13.9453 12.1875 13.0828 12.1875 12.0234V3.39844H12.6562C12.9151 3.39844 13.125 3.18853 13.125 2.92969C13.125 2.67084 12.9151 2.46094 12.6562 2.46094H11.7188H3.28125H2.34375ZM11.25 3.39844V12.0234C11.25 12.5672 10.8094 13.0078 10.2656 13.0078H4.73438C4.19063 13.0078 3.75 12.5672 3.75 12.0234V3.39844H11.25Z"
      fill={fill}
    />
  </svg>
);

export const ICON_NAME = 'bin';
